import { ProjectConfigView } from 'features/projects';

const ProjectConfigPage = () => <ProjectConfigView />;

export default ProjectConfigPage;
